export default __webpack_public_path__ + "static/contactSection-4f26012ffb8985c22810135ab7a1a604.jpg";